import { css } from '../utils/css';

export enum WaltStatus {
    Active = 'active', // Power on & user logged in
    Docked = 'docked', // Walt docked & charging
    LoggedOut = 'logged-out', // Power on & not docked & no user logged in
    PoweredOff = 'powered-off', // Power off
    NoConnection = 'no-connection', // Device state is unknown or has not been updated for 24+ hours

    // all of the below are deprecated and will fall off once Walt2DeviceManagementEnhancements is rolled out
    PoweredOnLoggedIn = 'powered-on-and-logged-in', // Power on & user logged in
    PoweredOnLoggedOut = 'powered-on-and-logged-out', // Power on & not docked & no user logged in
    NoConnectionAssigned = 'no-connection-assigned', // Not reported in ACTIVE_WALT_TIME_MINUTES and still assigned
                                                         // (reporting last known location) - (currently just comparing locationUpdated to ACTIVE_WALT_TIME_MINUTES)
    NoConnectionUnassigned = 'no-connection-unassigned', // Not reported in ACTIVE_WALT_TIME_MINUTES and unassigned
    Unassigned = 'unassigned', // Power On and unassigned
}

export const WaltStatusTranslation: { [key in WaltStatus]: string } = {
    [WaltStatus.Active]: 'walt.status.active',
    [WaltStatus.Docked]: 'walt.status.docked',
    [WaltStatus.LoggedOut]: 'walt.status.logged-out',
    [WaltStatus.PoweredOff]: 'walt.status.powered-off',
    [WaltStatus.NoConnection]: 'walt.status.no-connection',

    // all of the below are deprecated and will fall off once Walt2DeviceManagementEnhancements is rolled out
    [WaltStatus.PoweredOnLoggedIn]: 'walt.status.powered-on-logged-in',
    [WaltStatus.PoweredOnLoggedOut]: 'walt.status.powered-on-logged-out',
    [WaltStatus.NoConnectionAssigned]: 'walt.status.no-connection-assigned',
    [WaltStatus.NoConnectionUnassigned]: 'walt.status.no-connection-unassigned',
    [WaltStatus.Unassigned]: 'walt.status.unassigned',
};

export const WaltStatusToColor: { [key in WaltStatus]: string } = {
    [WaltStatus.Active]: css.brandingColors.W_GREEN,
    [WaltStatus.Docked]: css.brandingColors.W_LT_BLUE,
    [WaltStatus.LoggedOut]: css.brandingColors.W_YELLOW,
    [WaltStatus.PoweredOff]: css.brandingColors.W_MUTED_GRAY,
    [WaltStatus.NoConnection]: css.brandingColors.W_BRIGHT_RED,

    // all of the below are deprecated and will fall off once Walt2DeviceManagementEnhancements is rolled out
    [WaltStatus.PoweredOnLoggedIn]: css.brandingColors.W_GREEN,
    [WaltStatus.PoweredOnLoggedOut]: css.brandingColors.W_PURPLE,
    [WaltStatus.NoConnectionAssigned]: css.brandingColors.W_ORANGE,
    [WaltStatus.NoConnectionUnassigned]: css.brandingColors.W_RED,
    [WaltStatus.Unassigned]: css.brandingColors.W_LT_GRAY,
};
